import { toast } from '../components/Toast.tsx';
import { nativeShare } from './native.ts';
import { track } from './track.ts';

// Instagram's in-app browser may have neither the share sheet nor clipboard access, so the
// last resort is a sheet with the text selected, ready for a long-press copy.
type Fallback = (text: string) => void;
let showFallback: Fallback | null = null;
export function setShareFallback(fn: Fallback | null) {
  showFallback = fn;
}

/** Native share sheet where available (phones), otherwise copy to the clipboard. */
export async function share(opts: { text: string; url: string; title?: string; kind: string }): Promise<void> {
  const { text, url, title = 'ChessBut', kind } = opts;
  try {
    if (await nativeShare({ title, text, url })) {
      track('share', { kind, via: 'app' });
      return;
    }
  } catch {
    return; // dismissed
  }
  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      track('share', { kind, via: 'native' });
      return;
    } catch (err) {
      if ((err as Error).name === 'AbortError') return;
    }
  }
  await copy(`${text}\n${url}`, 'Copied! Paste it anywhere.');
  track('share', { kind, via: 'copy' });
}

export async function copy(text: string, message = 'Copied!') {
  try {
    await navigator.clipboard.writeText(text);
    toast(message);
  } catch {
    if (showFallback) showFallback(text);
    else toast(text);
  }
}
